export enum ApplicationStatus {
  DRAFT = 'Draft',
  UNDER_REVIEW = 'Under Review',
  RETURNED_TO_FACILITY_FOR_REVISION = 'Returned to Facility for Revision',
  APPLICATION_COMPLETE = 'Application Complete',
  PAYMENT_PENDING = 'Payment Pending',
  INCOMPLETE = 'Incomplete',
  APPLICATION_APPROVED = 'Application Approved',
  DECLINED = 'Declined'
}
